import { Component } from '@angular/core';

@Component({
  selector: 'app-permission-denied',
  standalone: true,
  imports: [],
  templateUrl: './permission-denied.component.html',
  styleUrl: './permission-denied.component.css'
})
export class PermissionDeniedComponent {

}
